var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        "custom-class": _vm.customClass,
        title: _vm.title || _vm.dialogTitle,
        width: _vm.width,
        top: _vm.top,
        "destroy-on-close": "",
        "append-to-body": _vm.appendToBody,
        "close-on-click-modal": false,
        "before-close": _vm.beforeClose,
        "show-close": _vm.showClose,
        "close-on-press-escape": _vm.closeOnPressEscape,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        opened: function ($event) {
          return _vm.$emit("opened")
        },
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _vm.visible ? _vm._t("default") : _vm._e(),
      _vm.showFooter
        ? _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm._t("footer-left"),
              _c("el-divider"),
              _vm.showCancel
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "info", disabled: _vm.loading },
                      on: { click: _vm.cancel },
                    },
                    [_vm._v(_vm._s(_vm.cancelText))]
                  )
                : _vm._e(),
              _vm.showConfirm
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: _vm.loading,
                        loading: _vm.loading,
                      },
                      on: { click: _vm.submit },
                    },
                    [_vm._v(_vm._s(_vm.submitText))]
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }